export const loadClient = (clientSrc: string): Promise<void> => {
  return new Promise<void>((resolve) => {
    const scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.src = clientSrc;
    scriptTag.onload = () => resolve();
    document.body.appendChild(scriptTag);
  });
};
